// Polyfills
import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';

import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/lib/integration/react';
import './wdyr';
import { persistor, store } from './store/index';
import WPLoadable from './components/WPLoadable';

const App = WPLoadable({
  loader: () => import(/* webpackChunkName: 'scripts/app' */ './containers/App'),
});

export const app = {
  cssRetries: 0,
  fetchRetries: 0,

  run() {
    this.render(App);
  },
  render(Component) {
    const root = document.getElementById('webproject_root');

    if (process.env.NODE_ENV !== 'development') {
      const myLoader = {};
      myLoader.log =
        myLoader.error =
        myLoader.info =
        myLoader.debug =
        myLoader.warn =
        myLoader.trace =
        myLoader.dir =
        myLoader.dirxml =
        myLoader.group =
        myLoader.groupEnd =
        myLoader.time =
        myLoader.timeEnd =
        myLoader.assert =
        myLoader.profile =
          function () {};
      window.console = myLoader;
    }

    const reactRoot = ReactDOM.createRoot(root);
    /* istanbul ignore next */
    if (root) {
      if (process.env.NODE_ENV !== 'development') {
        reactRoot.render(
          <StrictMode>
            <Router>
              <Provider store={store}>
                <PersistGate loading={null} persistor={persistor}>
                  <Component />
                </PersistGate>
              </Provider>
            </Router>
          </StrictMode>,
        );
      } else {
        reactRoot.render(
          <Router>
            <Provider store={store}>
              <PersistGate loading={null} persistor={persistor}>
                <Component />
              </PersistGate>
            </Provider>
          </Router>,
        );
      }
    }
  },
};

app.run();
